import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: 2, px: { xs: 2, md: 0 } }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: '#999' }} />}
        aria-label="breadcrumb"
      >
        <Link
          component="button"
          onClick={() => navigate('/')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: '#666',
            textDecoration: 'none',
            '&:hover': { color: '#876513' },
          }}
        >
          <HomeIcon fontSize="small" />
          Home
        </Link>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast) {
            return (
              <Typography
                key={index}
                sx={{ color: '#876513', fontWeight: 500 }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              component="button"
              onClick={() => navigate(item.path)}
              sx={{
                color: '#666',
                textDecoration: 'none',
                '&:hover': { color: '#876513' },
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;
